const hasLocalStorage = () => {
  return !!window.localStorage;
};

export const load_storage = (key: string) => {
  if (hasLocalStorage()) {
    const stritem = localStorage.getItem(key);
    if (stritem && stritem !== "") {
      try {
        return JSON.parse(stritem);
      } catch (error) {
        return stritem;
      }
    }
  }

  return null;
};

export function save_storage<T>(key: string, value: T) {
  if (hasLocalStorage()) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}

export function remove_storage(key: string) {
  if (hasLocalStorage()) {
    localStorage.removeItem(key);
  }
}

export function clear_storage() {
  if (hasLocalStorage()) {
    localStorage.clear();
  }
}
